import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchLeadForm } from '../../api/fetch-lead-form';

export const fetchLeadFormThunk = createAsyncThunk(
    'fetchLeadForm',
    async () => fetchLeadForm(),
);
